import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";

const Referrel = (props) => {
  const { referrel } = props.match.params;

  const timerRef = useRef(null);
  const storeUrlRef = useRef(null);
  const deepLinkRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [os, setOs] = useState(null);
  const [appState, setAppState] = useState("checking"); // 'checking', 'installed', 'not-installed'
  const [countdown, setCountdown] = useState(0);
  const [browser, setBrowser] = useState(null);
  const [code,setCode] = useState(null);

  const api_url = localStorage.getItem("api_url");

  const handleFocus = () => {
    // When user comes back to the page after some time, assume app wasn't installed
    if (appState === "checking") {
      setTimeout(() => {
        if (appState === "checking") {
          setAppState("not-installed");
        }
      }, 100);
    }
  };

  const safariSpecificFlow = () => {
    if (os !== "ios" || browser !== "safari") return false;

    // For Safari, we use a different approach
    // First show the user what's happening
    setAppState("checking");
    setCountdown(2); // Shorter countdown for Safari

    // Start countdown
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Setup event listeners with focus detection
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("pagehide", handlePageHide);
    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);

    // Delay the deep link attempt slightly to allow UI to render
    setTimeout(() => {
      if (deepLinkRef.current && appState === "checking") {
        attemptDeepLink(deepLinkRef.current);
      }
    }, 500);

    return true;
  };

  // Detect OS
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setOs("ios");
      if (/CriOS/.test(userAgent)) {
        setBrowser("chrome");
      } else if (/Safari/.test(userAgent) && !/CriOS/.test(userAgent)) {
        setBrowser("safari");
      } else {
        setBrowser("other");
      }
    } else if (/android/i.test(userAgent)) {
      setOs("android");
      setBrowser("android");
    } else {
      setOs("other");
      setBrowser("other");
    }
  }, []);

  const redirectToWebSignup = (code) => {
    const cookies = new Cookies();
    cookies.set("signuptab", "yes", { path: "/" });
    cookies.set("referral_code", code, { path: "/" });
    props.history.replace({
      pathname: "/login",
      search: `?referral_code=${encodeURIComponent(code)}`,
    });
  };

  useEffect(() => {
    if (!referrel) {
      props.history.push("/login");
      return;
    }

    if (os === "other") {
      redirectToWebSignup(referrel);
      return;
    }

    if (os) {
      get_url();
    }

    return () => {
      // Cleanup all timeouts and event listeners
      if (timerRef.current) clearTimeout(timerRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("pagehide", handlePageHide);
      window.removeEventListener("blur", handleBlur);
    };
  }, [referrel, os]);

  const handleVisibilityChange = () => {
    if (document.hidden) {
      // App opened successfully
      setAppState("installed");
      if (timerRef.current) clearTimeout(timerRef.current);
    }
  };

  const handlePageHide = () => {
    setAppState("installed");
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  const handleBlur = () => {
    setAppState("installed");
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  const attemptDeepLink = (url) => {
    // For iOS, use a simulated click approach
    if (os === "ios") {
      if (browser == "safari") {
        safariSpecificFlow();
        return;
      }

      const link = document.createElement("a");
      link.href = url;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // For Android, use iframe approach
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      document.body.appendChild(iframe);

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 300);
    }
  };

  const progressiveFallback = () => {
    if (appState !== "checking") return;

    // First, try a faster deep link approach
    if (deepLinkRef.current) {
      window.location.href = deepLinkRef.current;
    }

    // Then set a final fallback to the app store
    timerRef.current = setTimeout(() => {
      if (appState === "checking" && storeUrlRef.current) {
        setAppState("not-installed");
        window.location.href = storeUrlRef.current;
      }
    }, 3000); // 3 seconds for final fallback
  };

  const get_url = async () => {
    try {
      setIsLoading(true);
      setError(null);
      setAppState("checking");
      setCountdown(3);

      const formdata = new FormData();
      formdata.append("referrel", referrel);

      const result = await axios.post(`${api_url}get_deep_urls`, formdata);
      const response = result.data;

      // console.log("result ",response)
      // return
      const store_url = response.isIos ? response.appstore : response.playstore;
      const deep_link = response.deeplink;

      storeUrlRef.current = store_url;
      deepLinkRef.current = deep_link;
      // setCode(response)

      // Setup detection events
      document.addEventListener("visibilitychange", handleVisibilityChange);
      window.addEventListener("pagehide", handlePageHide);
      window.addEventListener("blur", handleBlur);

      // Start countdown timer
      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      // Attempt deep link immediately
      attemptDeepLink(deep_link);

      // Set initial fallback timer
      timerRef.current = setTimeout(
        () => {
          if (appState === "checking") {
            // If app hasn't opened yet, try progressive fallback
            progressiveFallback();
          }
        },
        os === "ios" ? 800 : 1500
      );

      setIsLoading(false);
    } catch (err) {
      console.error("Deep link error:", err);
      setError("Failed to load redirect information. Please try again.");
      setIsLoading(false);
      setAppState("not-installed");
    }
  };

  const handleButtonClick = () => {
    if (os === "other" && referrel) {
      redirectToWebSignup(referrel);
      return;
    }

    const textToCopy = referrel;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        console.log("Text copied to clipboard:", textToCopy);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
    if (appState === "installed" && deepLinkRef.current) {
      // Retry opening the app
      attemptDeepLink(deepLinkRef.current);
    } else if (storeUrlRef.current) {
      // Go directly to store
      window.location.href = storeUrlRef.current;
    }
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex flex-col items-center py-8">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500 mb-6"></div>
          <p className="text-gray-600 text-lg">
            Preparing your app experience...
          </p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="text-center py-8">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-6">
            {error}
          </div>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full transition duration-300"
            onClick={get_url}
          >
            Try Again
          </button>
        </div>
      );
    }

    return (
      <div className="py-6 px-4">
        <div className="flex justify-center mb-8">
          <div className="bg-blue-100 rounded-full p-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
          </div>
        </div>

        {appState === "checking" ? (
          <>
            <h3 className="text-2xl font-bold text-center text-gray-800 mb-4">
              Opening App...
            </h3>
            <p className="text-gray-600 text-center mb-6">
              We're redirecting you to the app. This may take a moment.
            </p>

            <div className="mb-6">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">
                  Redirecting in
                </span>
                <span className="text-sm font-medium text-gray-700">
                  {countdown}s
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div
                  className="bg-blue-600 h-2.5 rounded-full"
                  style={{ width: `${100 - (countdown / 3) * 100}%` }}
                ></div>
              </div>
            </div>
          </>
        ) : appState === "installed" ? (
          <>
            <h3 className="text-2xl font-bold text-center text-gray-800 mb-4">
              App Ready!
            </h3>
            <p className="text-gray-600 text-center mb-8">
              The app is installed on your device. Tap below to open it.
            </p>
          </>
        ) : (
          <>
            <h3 className="text-2xl font-bold text-center text-gray-800 mb-4">
              Get the App
            </h3>
            <p className="text-gray-600 text-center mb-8">
              Redirecting you to download the app for the best experience.
            </p>
          </>
        )}

        <button
          className={`w-full py-4 px-6 rounded-xl font-bold text-white text-lg transition duration-300 ${
            appState === "installed"
              ? "bg-green-600 hover:bg-green-700"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
          onClick={handleButtonClick}
        >
          {appState === "installed"
            ? "Open App Now"
            : os === "ios"
            ? "Download on App Store"
            : os === "android"
            ? "Get it on Google Play"
            : "Download App"}
        </button>

        {appState === "checking" && (
          <p className="text-gray-500 text-sm text-center mt-6">
            If the app doesn't open automatically, tap the button above.
          </p>
        )}
      </div>
    );
  };

  if (os === "other" && referrel) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden w-full max-w-md p-8 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-500 mx-auto mb-4"></div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">Opening signup...</h2>
          <p className="text-gray-600">
            Redirecting you to create your account with referral code applied.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden w-full max-w-md">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6 text-white text-center">
          <h2 className="text-2xl font-bold">App Redirect</h2>
          <p className="opacity-90 mt-2">Seamless app experience</p>
        </div>

        {renderContent()}

        <div className="bg-gray-50 px-6 py-4 text-center text-sm text-gray-500 border-t">
          <p>Having trouble? Contact support@example.com</p>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Referrel);
